import { baseApi, getErrorMessage } from '@/shared/api';
import { mapSavedView } from '../libs/mapSavedView';
import type { SavedViewRecord } from '../model/types';
import type { SavedViewDTO, SavedViewStorage } from './types';

export const getSavedViews = async (): Promise<SavedViewRecord[]> => {
  const { data, error } = await baseApi
    .from('saved_view')
    .select('*')
    .order('updated_at', { ascending: false })
    .returns<SavedViewDTO[]>();

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return data.map(mapSavedView);
};

export const deleteSavedView = async (uuid: string) => {
  const { error } = await baseApi.from('saved_view').delete().eq('uuid', uuid);

  if (error) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }
};

export const createSavedView = async (
  storage: SavedViewStorage,
  name: string,
  snapshot: unknown,
) => {
  const { data, error } = await baseApi
    .from('saved_view')
    .insert([
      {
        saved_view_name: name,
        saved_view: {
          storage,
          snapshot,
        },
      },
    ])
    .select()
    .returns<[SavedViewDTO]>();

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return mapSavedView(data[0]);
};

export const updateSavedView = async (
  uuid: string,
  savedView: SavedViewRecord['savedView'],
) => {
  const { data, error } = await baseApi
    .from('saved_view')
    .update({
      saved_view: savedView,
      updated_at: new Date().toISOString(),
    })
    .eq('uuid', uuid)
    .select()
    .returns<[SavedViewDTO]>();

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return mapSavedView(data[0]);
};
